
<div class="breadcrumb-wrapper d-flex">
  <i class="mdi mdi-cog text-blue mr-4 font-size-20"></i>
  <h1>Gerenciamento de configurações</h1>
</div>
<router-outlet></router-outlet>

